import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaginatorComponent } from './paginator/paginator.component';
import { PasswordInputComponent } from './password-input/password-input.component'

@NgModule({
  declarations: [PaginatorComponent,PasswordInputComponent],
  entryComponents: [PaginatorComponent,PasswordInputComponent],
  imports: [
    CommonModule,
  ],
  exports: [
      PaginatorComponent,
      PasswordInputComponent
  ]
})
export class SharedModule { }
